import { render, staticRenderFns } from "./ReportTabUserGDS.vue?vue&type=template&id=13984654&scoped=true&lang=pug"
import script from "./ReportTabUserGDS.vue?vue&type=script&lang=js"
export * from "./ReportTabUserGDS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13984654",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13984654')) {
      api.createRecord('13984654', component.options)
    } else {
      api.reload('13984654', component.options)
    }
    module.hot.accept("./ReportTabUserGDS.vue?vue&type=template&id=13984654&scoped=true&lang=pug", function () {
      api.rerender('13984654', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/datastudio/components/ReportTabUserGDS.vue"
export default component.exports